import { v4 as uuid } from 'uuid';

import { EVENT_TYPES } from '../../constants';

export const createDraft = latlng => {
  const id = uuid();
  const category = null;
  const payload = { category, id, latlng };
  return {
    payload,
    type: EVENT_TYPES.DRAFT_CREATE,
  };
};

export const cancelDraft = () => ({
  type: EVENT_TYPES.DRAFT_CANCEL,
});
